import React from 'react';
import { MessageSquare } from 'lucide-react';
export function ContactHero() {
  return <section className="relative bg-ink pt-16 pb-20 lg:pt-20 lg:pb-24 overflow-hidden" data-id="element-870">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-storm-red transform skew-x-12 translate-x-32 opacity-10 pointer-events-none" data-id="element-871" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-872">
        <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-873">
          <MessageSquare className="w-4 h-4" data-id="element-874" />
          We're Here to Help
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-[1.1]" data-id="element-875">
          Contact Storm Taekwondo
        </h1>
        <p className="text-xl text-off-white max-w-2xl mx-auto leading-relaxed" data-id="element-876">
          Have a question about classes, programs, summer camp, reviews, or
          getting started? Contact Storm Taekwondo in Farmington Hills.
        </p>
      </div>
    </section>;
}